import React from "react";
import LegalLayout, { Section } from "@/components/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy">
      <Section title="1. Who We Are">
        <p>SetuBuild Technologies (“we”, “us”, “our”) operates the Setubuild.OS platform. We are the <strong>Data Fiduciary</strong> under India’s Digital Personal Data Protection Act, 2023 (DPDPA).</p>
        <p>Grievance Officer: <span className="mono">setubuildtechnologies@gmail.com</span> · +91 97667 44746</p>
      </Section>

      <Section title="2. What Data We Collect">
        <ul className="list-disc pl-6 space-y-1">
          <li><strong>Account data:</strong> name, email, company, role, hashed password.</li>
          <li><strong>Project data:</strong> project details, materials, equipment, team members.</li>
          <li><strong>Site content:</strong> photos, voice recordings, incident notes you upload.</li>
          <li><strong>Attendance:</strong> face descriptor (128-float vector, not the image), selfie, GPS coordinates, timestamps — for workers registered by you.</li>
          <li><strong>WhatsApp messages:</strong> outbound reports (with recipient consent) via Twilio.</li>
          <li><strong>Payment:</strong> subscription plan + status. Card/UPI data is handled entirely by Razorpay — we never see it.</li>
          <li><strong>Technical:</strong> IP address, browser type, action logs.</li>
        </ul>
      </Section>

      <Section title="3. Why We Collect It (Purposes)">
        <ul className="list-disc pl-6 space-y-1">
          <li>Provide, secure, and operate the platform for you.</li>
          <li>Run AI features (photo inspection, chat, DPR, voice transcription).</li>
          <li>Verify attendance & prevent fraud.</li>
          <li>Send site reports to your designated recipients (only with their opt-in).</li>
          <li>Process subscription payments via Razorpay.</li>
          <li>Meet legal, tax, and safety compliance obligations.</li>
        </ul>
      </Section>

      <Section title="4. Legal Basis">
        <p>We rely on your <strong>explicit consent</strong> (given at signup) and <strong>legitimate uses</strong> as defined in Section 7 DPDPA (contractual necessity, safety, compliance).</p>
      </Section>

      <Section title="5. Sharing with Third Parties">
        <ul className="list-disc pl-6 space-y-1">
          <li><strong>AI processors:</strong> Emergent LLM Gateway (Anthropic, Google, OpenAI) — text/image/audio you submit is sent for processing and returned. No permanent training on your data.</li>
          <li><strong>Twilio:</strong> WhatsApp message delivery.</li>
          <li><strong>Razorpay:</strong> payment processing.</li>
          <li><strong>Emergent Auth:</strong> Google social login (Google is the identity provider).</li>
        </ul>
        <p>We do <strong>not</strong> sell your data. Ever.</p>
      </Section>

      <Section title="6. Biometric & Sensitive Data">
        <p>Face descriptors (numeric embeddings) are stored server-side; the raw selfie is stored only if you enable it in settings. Descriptors cannot be reversed into a photo. You can delete any worker (and their biometric data) at any time.</p>
      </Section>

      <Section title="7. Your Rights (DPDPA Chapter III)">
        <ul className="list-disc pl-6 space-y-1">
          <li><strong>Access:</strong> download all your data any time from Settings → “Export my data”.</li>
          <li><strong>Correction:</strong> edit any field in Settings.</li>
          <li><strong>Erasure:</strong> click “Delete my account” — we permanently wipe within 24 hours.</li>
          <li><strong>Withdraw consent:</strong> stop the flow of data by deleting your account.</li>
          <li><strong>Grievance:</strong> email <span className="mono">setubuildtechnologies@gmail.com</span>. We respond within 30 days.</li>
        </ul>
      </Section>

      <Section title="8. Retention">
        <p>Account data is kept while your account is active + 90 days after deletion request (for legal/tax records where applicable). AI outputs older than 12 months are auto-purged.</p>
      </Section>

      <Section title="9. Security">
        <p>Bcrypt password hashing, HTTPS everywhere, HttpOnly cookies for social login, JWT for API auth, rate-limiting on sensitive endpoints, per-user data isolation in the database, audit logs of all sensitive actions.</p>
      </Section>

      <Section title="10. Breach Notification">
        <p>If a data breach occurs, we notify affected users and the Data Protection Board of India within 72 hours as required by DPDPA.</p>
      </Section>

      <Section title="11. Children">
        <p>The platform is not intended for users under 18. We do not knowingly collect children’s data.</p>
      </Section>

      <Section title="12. Changes to This Policy">
        <p>We will post updates on this page with a new “Last updated” date. Material changes will be emailed 14 days in advance.</p>
      </Section>

      <Section title="13. Contact">
        <p>SetuBuild Technologies, Bharat · Grievance Officer — <span className="mono">setubuildtechnologies@gmail.com</span> · +91 97667 44746</p>
        <p>Reach us anytime via our <a href="/contact" className="text-primary underline">Contact page</a>.</p>
      </Section>
    </LegalLayout>
  );
}
